export const compareDialog = {
  "title": "Compare PDF Files",
  "compareFiles": "Compare Files",
  "comparePageRange": "Compare Page Range",
  "oldFile": "Old File",
  "newFile": "New File",
  "choose": "Choose",
  "to": "To",
  "ok": "OK",
  "downloadFile": "Download File",
  "notPDF": "This file is not PDF",
  "overSize": "This file is over size(1G)",
  "cancel": "Cancel",
  "fileSelectPlaceHolder": "Select A PDF File",
  "resultTitle": "Document comparing...",
  "resultComplete": "Compare Complete",
  "resultSuccess": "Compare Success",
  "selectTowDifferentDoc": "Please select two different documents",
  "selectSameNumber": "Please select the same number of pages for comparison",
  "passwordInput": {
    "title": "Password",
    "label": "Please input password:",
    "errorMessage": "Password Incorrect"
  },
  "options": {
    "title": "Options",
    "CompareTextOnly": "Compare Text Only",
    "setDefaultText": "Set current properties as default",
    "include": {
      "title": "Include",
      "compareText": "Compare Text Only",
      "compareTable": "Compare Table",
      "deletePage": "Detect page deletions or inserts"
    },
    "replace": "Replace Objects",
    "insert": "Insert Objects",
    "delete": "Delete Objects",
    "color": "Marking Color",
    "opacity": "Opacity",
    "line": "Line Thickness"
  },
  "compareResultDocName": "The result of Comparison",
  "xfaErrorMsg": "Please don't choose XFA files!",
  "fileRangeErrorMsg": "The starting page number must be less than or as same as the ending one.",
  "compareFilesSuccessMsg": "Compare Files Successfully",
  "openFileDirectly": "Open File Directly",
  "saveAndOpenFile": "Save&Open",
  "compareResultStrings": {
    "IDS_STRING_DELETE": "Deleted ",
    "IDS_STRING_INSERT": "Inserted ",
    "IDS_STRING_REPLACE": "Replaced ",
    "IDS_STR_TEXTFONTCHANGE": "Font changed.",
    "IDS_STR_TEXTFONTSIZECHANGE": "Font-size changed.",
    "IDS_STRING_NEW": "[New Text]: ",
    "IDS_STRING_OLD": "[Old Text]: ",
    "IDS_STR_TEXTATTRICHANGED": "Text Attributes Changed",
    "IDS_STRING_TEXT": "Text",
    "IDS_STRING_IMAGE": "Image",
    "IDS_STRING_PATH": "Path",
    "IDS_STRING_SHADING": "Shading",
    "IDS_STRING_ANNOT": "Annot",
    "IDS_STRING_TABLE": "Table",
    "IDS_COMPARE_TOTAL_CHANGES": "Total Changes",
    "IDS_COMPARE_REPLACEMENTS": "Replacements",
    "IDS_COMPARE_INSERT": "Insertions",
    "IDS_COMPARE_DELETE": "Deletions",
    "IDS_COMPARE_SUMMARY": "Summary",
    "IDS_COMPARE_RESULTS": "Compare Results",
    "IDS_COMPARE_VERSUS": "versus",
    "IDS_COMPARE_STYLING": "Styling",
    "IDS_COMPARE_ANNOTATIONS": "Annotations",
    "IDS_COMAPRE_GOTOFIRST": "Go to the First Change (page %d)",
    "IDS_OLD_FILE": "Old File:",
    "IDS_NEW_FILE": "New File:",
    "IDS_COMPARE_CONTENT": "Content",
    "IDS_COMPARE_STYLEANDANNOT": "Styling and Annotations",
    "IDS_PAGES": "%d page(s)",
    "IDS_STR_TEXTFONTCOLORCHANGE": "Font-color changed."
  }
}
